import api from '../../../services/Api';
import { IAuditoriaCircularidadeTransitoriaResultado } from '../interfaces/IAuditoriaCircularidadeTransitoria';

interface BuscarParams {
  empresaId: number;
  periodo: string | undefined;
}

export const AuditoriaCircularidadeTransitoriaService = {
  buscarResultado: async (params: BuscarParams): Promise<IAuditoriaCircularidadeTransitoriaResultado> => {
    const response = await api.get<IAuditoriaCircularidadeTransitoriaResultado>(
      'auditoria-circularidade-transitoria/resultado',
      { params: { empresaIds: params.empresaId, periodo: params.periodo } }
    );
    return response.data;
  },
};
